import { render } from "./ContinueShoppingModal.vue?vue&type=template&id=efd7589a&scoped=true&ts=true"
import script from "./ContinueShoppingModal.vue?vue&type=script&lang=ts"
export * from "./ContinueShoppingModal.vue?vue&type=script&lang=ts"

import "./ContinueShoppingModal.vue?vue&type=style&index=0&id=efd7589a&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd7589a"]])

export default __exports__